import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Select, Button, Card, DatePicker, Tag, Tabs, Tooltip } from "antd";
import { useParams } from "react-router-dom";
import NoSearchAssistant from "../../assets/images/research-no-items.svg";
import CopyIocn from "../../assets/images/research-copy-icon.svg";
import EditIcon from "../../assets/images/research-edit-icon.svg";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { ArrowUpOutlined, HistoryOutlined } from "@ant-design/icons";
import lang from "../../helper/langHelper";
import { useResearchHistory } from "../../hooks/useResearchHistory";
import ResearchHistorySidebar from "../../components/ResearchHistorySidebar";
import apiPath from "../../constants/apiPath";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import ContentIdeas from "./ContentIdeasTabs";
import GraphicalInsights from "./GraphicalInsightsTabs";

const { TabPane } = Tabs;

// List of countries (you can expand this or import from a library like 'countries-list')
const countries = [
  { name: "Afghanistan", code: "AF" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "Andorra", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Brazil", code: "BR" },
  { name: "Brunei", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cabo Verde", code: "CV" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo (Congo-Brazzaville)", code: "CG" },
  { name: "Costa Rica", code: "CR" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Democratic Republic of the Congo", code: "CD" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Eswatini", code: "SZ" },
  { name: "Ethiopia", code: "ET" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Greece", code: "GR" },
  { name: "Grenada", code: "GD" },
  { name: "Guatemala", code: "GT" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Honduras", code: "HN" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Laos", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia", code: "FM" },
  { name: "Moldova", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montenegro", code: "ME" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "North Korea", code: "KP" },
  { name: "North Macedonia", code: "MK" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Qatar", code: "QA" },
  { name: "Romania", code: "RO" },
  { name: "Russia", code: "RU" },
  { name: "Rwanda", code: "RW" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia", code: "RS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Korea", code: "KR" },
  { name: "South Sudan", code: "SS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syria", code: "SY" },
  { name: "Taiwan", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Vatican City", code: "VA" },
  { name: "Venezuela", code: "VE" },
  { name: "Vietnam", code: "VN" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];

const { Option } = Select;

const todayDate = new Date();

const CollaborationTabs = ({ onWrite }) => {
  const { request } = useRequest();
  const { id: clientId } = useParams(); // Get client ID from route params in Admin
  const [regions, setRegions] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingRegions, setLoadingRegions] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  // Lets "Stop" abort the in-flight /rag/stream fetch — same pattern as the
  // Writing Assistant's stop control.
  const researchAbortRef = useRef(null);
  const [generatedText, setGeneratedText] = useState("");
  const [headlines, setHeadlines] = useState([]);
  const [sourceConfidence, setSourceConfidence] = useState({});
  const [sourceUrls, setSourceUrls] = useState({});
  const [topicsList, setTopicsList] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [researchData, setResearchData] = useState([]);
  const [interestOverTime, setInterestOverTime] = useState([]);
  const [contentHeadlines, setContentHeadlines] = useState([]);
  const [contentQuestions, setContentQuestions] = useState([]);
  const [relatedHeadlines, setRelatedHeadlines] = useState([]);
  const [relatedQuestions, setRelatedQuestions] = useState([]);
  const [topKeyword, setTopKeyword] = useState("");
  const [cardData, setCardData] = useState([]);
  const [form] = Form.useForm();
  const [ragResponse, setRagResponse] = useState(null);
  const [showAnalysis, setShowAnalysis] = useState(false);
  const [bestModel, setBestModel] = useState("");
  // For editing headlines
  const [editingHeadlineIndex, setEditingHeadlineIndex] = useState(null);
  const [editingHeadlineValue, setEditingHeadlineValue] = useState("");
  // For editing topics
  const [editingTopicIndex, setEditingTopicIndex] = useState(null);
  const [editingTopicValue, setEditingTopicValue] = useState("");

  // Prompt history (brand Research Assistant) - pass clientId to load client's history
  const [historyOpen, setHistoryOpen] = useState(false);
  const [currentResearchId, setCurrentResearchId] = useState(null);
  const {
    researchHistories,
    saveResearchHistory,
    deleteResearchHistory,
    clearAllResearchHistories,
  } = useResearchHistory(clientId);

  const fetchDeepSeekContent = async (prompt) => {
    try {
      const res = await request({
        url: "/admin/access-module/research/deepseek", // Updated endpoint for Admin
        method: "POST",
        data: { prompt },
      });
      return res?.data?.content || "No content generated.";
    } catch (error) {
      console.error("Error fetching DeepSeek content:", error);
      throw error;
    }
  };

  const fetchRegions = async () => {
    try {
      setLoadingRegions(true);
      const res = await request({
        url: "/admin/access-module/research/region",
        method: "GET",
      }); // Updated endpoint for Admin
      const list = Array.isArray(res?.data?.Regions)
        ? res.data.Regions
        : Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
            ? res
            : [];
      setRegions(list);
      // Do not select any region by default
      if (list.length > 0) {
        setCities([]); // No cities until region is selected
      }
    } catch (e) {
    } finally {
      setLoadingRegions(false);
    }
  };

  const fetchResearch = async (topic, domain, region, language) => {
    try {
      setLoadingRegions(true);
      const payload = { topic, domain, country: region, language };
      const res = await request({
        url: "/admin/access-module/research/run",
        data: payload,
        method: "POST",
      }); // Updated endpoint for Admin
      console.log("Research Data:", res);
      setResearchData(res.data);
    } catch (e) {
    } finally {
      setLoadingRegions(false);
    }
  };

  useEffect(() => {
    fetchRegions();
  }, []);

  const startRagStream = async (payload) => {
    // setLoadingSubmit(true);
    setRagResponse(null);
    setBestModel("");
    setShowAnalysis(false);

    // Goes through the Node backend's proxy (not straight to Imergey-AI) so
    // the browser only ever needs the Node backend's own URL — Imergey-AI's
    // address lives in ONE place, the backend's IMERGEY_AI_URL env var.
    const response = await fetch(`${apiPath.baseURL}admin/access-module/research/rag-stream`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/event-stream",
        Authorization: `Bearer ${localStorage.getItem("admin_token") || ""}`,
      },
      body: JSON.stringify(payload),
      signal: researchAbortRef.current?.signal,
    });

    if (!response.ok || !response.body) {
      throw new Error("Failed to start RAG stream");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");

    let buffer = "";
    return new Promise(async (resolve, reject) => {
      try {
        while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });

          // SSE messages end with double newline
          const events = buffer.split("\n\n");
          buffer = events.pop(); // keep incomplete chunk

          for (const event of events) {
            if (!event.startsWith("data:")) continue;

            const data = JSON.parse(event.replace("data:", "").trim());

            if (data.status === "completed") {
              setRagResponse(data.result);
              setBestModel(data.result?.best_model || "");

              setLoadingSubmit(false);
              // Resolve the full result object (best_answer text AND structured
              // fields like interest_over_time) so the caller can use real
              // Google Trends data, not just the parsed text table.
              resolve(data.result || {});
              return;
            }

            if (data.status === "failed") {
              setLoadingSubmit(false);
              reject(new Error("RAG failed"));
              return;
            }
          }
        }
      } catch (err) {
        reject(err);
      }
    });
  };

  const renderModelAnswer = (model, content) => {
    const isError =
      typeof content === "string" && content.toLowerCase().includes("error");

    return (
      <Card key={model} size="small" className="model-answer-card">
        <div className="analysis-card-header">
          <Tag color={isError ? "red" : "blue"}>{model.toUpperCase()}</Tag>

          <Button
            size="small"
            onClick={() => copyToClipboard(content, `${model} answer`)}
          >
            <img src={CopyIocn} alt="Copy" />
          </Button>
        </div>

        <div className="analysis-card-body">
          {isError ? (
            <p className="error-text">{content}</p>
          ) : (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          )}
        </div>
      </Card>
    );
  };

  const AnalysisCard = ({ title, content, copyLabel }) => {
    const handleCopy = async () => {
      await navigator.clipboard.writeText(
        typeof content === "string"
          ? content
          : JSON.stringify(content, null, 2),
      );
      ShowToast(`${copyLabel} copied`, Severty.SUCCESS);
    };

    return (
      <Card size="small" className="analysis-card">
        <div className="analysis-card-header">
          <h6>{title}</h6>
          <Button size="small" onClick={handleCopy}>
            <img src={CopyIocn} alt="Copy" />
          </Button>
        </div>

        <div className="analysis-card-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {typeof content === "string"
              ? content
              : `\`\`\`json\n${JSON.stringify(content, null, 2)}\n\`\`\``}
          </ReactMarkdown>
        </div>
      </Card>
    );
  };

  // const handleRunResearch = async (values) => {
  //   try {
  //     setLoadingSubmit(true);
  //     setShowAnalysis(false);
  //     setRagResponse(null);

  //     const { topic, domain, region, city, language, researchMode } =
  //       values || {};
  //     const regionName =
  //       regions.find((r) => (r?._id || r?.id) === region)?.name || "";

  //     const ragPayload = {
  //       prompt: topic,
  //       models: ["llama", "deepseek", "openai"],
  //       mode: researchMode ?? "files",
  //       username: clientId,
  //       meta: {
  //         topic,
  //         domain,
  //         region: regionName,
  //         city,
  //         language,
  //       },
  //     };

  //     await startRagStream(ragPayload);
  //   } catch (e) {
  //     console.error(e);
  //     setLoadingSubmit(false);
  //     ShowToast("Failed to start research", Severty.ERROR);
  //   }
  // };

    // Ask the AI backend for a real top-result source URL per headline, so
    // every headline is a real, clickable link — not just the ones the news
    // scrape happened to return with a URL already attached. Best-effort:
    // never throws. Returns { query: url }.
    const fetchHeadlineSources = async (queries) => {
      try {
        const unique = Array.from(new Set((queries || []).filter(Boolean))).slice(0, 30);
        if (unique.length === 0) return {};
        const res = await fetch(`${apiPath.baseURL}admin/access-module/research/resolve-sources`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("admin_token") || ""}` },
          body: JSON.stringify({ queries: unique }),
        });
        if (!res.ok) return {};
        const body = await res.json();
        const data = body?.data || {};
        const sources = data?.sources || {};
        return Object.fromEntries(Object.entries(sources).filter(([, url]) => !!url));
      } catch (e) {
        console.error("resolve-sources failed:", e);
        return {};
      }
    };

    // Ask the AI backend how many independent sources agree with each
    // headline (title-word-overlap heuristic on the server). Best-effort:
    // never throws. Returns { query: count }.
    const fetchHeadlineConfidence = async (queries) => {
      try {
        const unique = Array.from(new Set((queries || []).filter(Boolean))).slice(0, 30);
        if (unique.length === 0) return {};
        const res = await fetch(`${apiPath.baseURL}admin/access-module/research/resolve-confidence`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("admin_token") || ""}` },
          body: JSON.stringify({ queries: unique }),
        });
        if (!res.ok) return {};
        const body = await res.json();
        return body?.data?.confidence || {};
      } catch (e) {
        console.error("resolve-confidence failed:", e);
        return {};
      }
    };

    // Shows the actual corroborating sources as small favicons (+N overflow),
    // with a hover tooltip listing which sites and linking to each article.
    // Hidden until resolved (no misleading "0 sources" flash).
    const CONFIDENCE_MAX_VISIBLE = 3;
    const renderConfidenceBadge = (label) => {
      const data = sourceConfidence[label];
      if (!data) return null;
      const { count = 0, sources = [] } = data;
      if (count === 0) {
        return <span className="confidence-badge confidence-badge-none">Unverified</span>;
      }
      const visible = sources.slice(0, CONFIDENCE_MAX_VISIBLE);
      const extra = count - visible.length;
      const tooltipContent = (
        <div className="confidence-tooltip">
          {sources.map((s, idx) => (
            <a key={idx} href={s.url} target="_blank" rel="noopener noreferrer" className="confidence-tooltip-row">
              <img src={`https://www.google.com/s2/favicons?domain=${s.domain}&sz=32`} alt="" className="confidence-favicon" />
              <span className="confidence-tooltip-domain">{s.domain}</span>
            </a>
          ))}
        </div>
      );
      return (
        <Tooltip title={tooltipContent} overlayClassName="confidence-tooltip-overlay">
          <span className="confidence-sources">
            {visible.map((s, idx) => (
              <img key={idx} src={`https://www.google.com/s2/favicons?domain=${s.domain}&sz=32`} alt={s.domain} className="confidence-favicon" />
            ))}
            {extra > 0 && <span className="confidence-more">+{extra}</span>}
          </span>
        </Tooltip>
      );
    };

    const handleRunResearch = async (values) => {
      researchAbortRef.current = new AbortController();
      try {
        setLoadingSubmit(true);
        const { topic, language } = values || {};
        await fetchResearch(topic, undefined, undefined, language);
  //       const prompt = `You are a research assistant. Based on the inputs, return ONLY these sections and nothing else:

  // ### Top 10 Headlines
  // 1. ...
  // 2. ...
  // 3. ...
  // 4. ...
  // 5. ...
  // 6. ...
  // 7. ...
  // 8. ...
  // 9. ...
  // 10. ...

  // ### Top 10 Topics
  // 1. ...
  // 2. ...
  // 3. ...
  // 4. ...
  // 5. ...
  // 6. ...
  // 7. ...
  // 8. ...
  // 9. ...
  // 10. ...

  // ### Top 10 Keywords
  // 1. ...
  // 2. ...
  // 3. ...
  // 4. ...
  // 5. ...
  // 6. ...
  // 7. ...
  // 8. ...
  // 9. ...
  // 10. ...

  // ### Create content ideas for the topic
  // 1. ...
  // 2. ...
  // 3. ...
  // 4. ...
  // 5. ...
  // 6. ...
  // 7. ...
  // 8. ...
  // 9. ...
  // 10. ...

  // ### Top 10 Questions Asked on the Internet related to the topic
  // 1. ...
  // 2. ...
  // 3. ...
  // 4. ...
  // 5. ...
  // 6. ...
  // 7. ...
  // 8. ...
  // 9. ...
  // 10. ...

  // ### All Headlines Related to the Top Keyword of the topic
  // 1. ...
  // 2. ...
  // 3. ...
  // 4. ...
  // 5. ...
  // 6. ...
  // 7. ...
  // 8. ...
  // 9. ...
  // 10. ...

  // ### All Questions Related to the Top Keyword of the topic
  // 1. ...
  // 2. ...
  // 3. ...
  // 4. ...
  // 5. ...
  // 6. ...
  // 7. ...
  // 8. ...
  // 9. ...
  // 10. ...

  // ### Top Search Keyword of the Day
  // 1. ...

  // ### 6 top keywords details for the topic. Use this structure for each card and volume of last 3 months:
  // ### Card 1
  // - Keyword: ...
  // - Search volume: ...
  // - Subtopic bullets:
  //   - ...
  //   - ...
  // - trending points of this keyword:
  //   - ...
  //   - ...
  // ### Card 2
  // - Keyword: ...
  // - Search volume: ...
  // - Subtopic bullets:
  //   - ...
  //   - ...
  // - trending points of this keyword:
  //   - ...
  //   - ...
  // ### Card 3
  // - Keyword: ...
  // - Search volume: ...
  // - Subtopic bullets:
  //   - ...
  //   - ...
  // - trending points of this keyword:
  //   - ...
  //   - ...
  // ### Card 4
  // - Keyword: ...
  // - Search volume: ...
  // - Subtopic bullets:
  //   - ...
  //   - ...
  // - trending points of this keyword:
  //   - ...
  //   - ...
  // ### Card 5
  // - Keyword: ...
  // - Search volume: ...
  // - Subtopic bullets:
  //   - ...
  //   - ...
  // - trending points of this keyword:
  //   - ...
  //   - ...
  // ### Card 6
  // - Keyword: ...
  // - Search volume: ...
  // - Subtopic bullets:
  //   - ...
  //   - ...
  // - trending points of this keyword:
  //   - ...
  //   - ...

  // ### Topic Interest Over Last 3 Months (Weekly)
  // | Date (YYYY-MM-DD) | Interest |
  // |-------------------|----------|
  // | [date 12]          | ...      |
  // | [date 11]          | ...      |
  // | [date 10]          | ...      |
  // | [date 9]          | ...      |
  // | [date 8]          | ...      |
  // | [date 7]          | ...      |
  // | [date 6]          | ...      |
  // | [date 5]          | ...      |
  // | [date 4]          | ...      |
  // | [date 3]         | ...      |
  // | [date 2]         | ...      |
  // | [date 1]         | ...      |

  // Constraints:
  // - Do not include any intro, explanation, or summary text.
  // - Use exactly the above markdown headings and numbered lists/tables.
  // - For the "Topic Interest Over Last 3 Months (Weekly)" section, use the last 12 weeks as actual dates (YYYY-MM-DD, Mondays only, most recent first from ${todayDate} date ).
  // - Tailor items to the inputs.

  // Inputs:
  // - Topic: ${topic || ""}
  // - Domain: ${domain || ""}
  // - Region: ${regionName}
  // - City: ${city || ""}
  // - Language: ${language || "English"}`.trim();

        // if (typeof fetchDeepSeekContent !== "function") {
        //   setGeneratedText("");
        //   setHeadlines([]);
        //   setTopicsList([]);
        //   setKeywords([]);
        //   setContentHeadlines([]);
        //   setContentQuestions([]);
        //   setRelatedHeadlines([]);
        //   setRelatedQuestions([]);
        //   setTopKeyword("");
        //   setCardData([]);
        //   setInterestOverTime([]);
        //   console.error("fetchDeepSeekContent is not available in scope.");
        //   return;
        // }

        // setLoadingSubmit(true);
        setShowAnalysis(false);
        setRagResponse(null);

        const researchMode = values?.researchMode;
        // const regionName = regions.find((r) => (r?._id || r?.id) === region)?.name || "";

        const basePrompt = researchMode === "files" 
          ? `${topic}. Please recommend topics to consider. Provide results based on date and relevance.`
          : topic;

        const ragPayload = {
          prompt: basePrompt,
          models: ["deepseek", "openai"], // have to add "llama"
          // models: ["llama", "deepseek", "openai"],
          mode: researchMode || "files",
          username: clientId,
          meta: {
            topic,
            language,
          },
        };

        const ragResult = await startRagStream(ragPayload);
        const text = ragResult?.best_answer || "";
        setGeneratedText(text || "");

        // Helper to extract a numbered list from a section
        // Language-agnostic: extract all sections by order, not header text
        const extractOrderedSections = (text) => {
          if (typeof text !== 'string' || !text.trim()) return [];
          // Split by level-3 headers (###)
          const headerSplit = text.split(/\n(?=###\s*)/g).map(s => s.trim()).filter(Boolean);
          const blocks = [];
          headerSplit.forEach(block => {
            const lines = block.split('\n').map(l => l.trim()).filter(Boolean);
            const items = [];
            for (let i = 0; i < lines.length; i++) {
              const m = lines[i].match(/^\s*\d+\.\s*(.+)/);
              if (m) items.push(m[1].trim());
            }
            if (items.length) blocks.push(items.slice(0, 10));
          });
          return blocks;
        };

        // Helper to extract a single item from a section (by order)
        const extractSingleFromBlock = (block) => {
          if (!block || !block.length) return '';
          return block[0];
        };

        // Helper to extract card data (supports Arabic/English)
        const extractCards = (text) => {
          if (typeof text !== 'string' || !text.trim()) return [];

          // Everything before "### Card 1" is preamble (other sections), so drop
          // index 0 outright — this replaces the old empty-check + cards.shift()
          // combo that was silently dropping a real card.
          const cardBlocks = text
            .split(/###\s*Card\s*\d+/i)
            .slice(1)
            .map(b => b.trim())
            .filter(b => b);

          const isCardLabel = (b) =>
            /^(?:Keyword|Search volume|حجم البحث|كلمة|Subtopic bullets|trending points)/i.test(b);

          const cards = [];
          cardBlocks.forEach(block => {
            const lines = block.split('\n').map(l => l.trim()).filter(Boolean);
            if (lines.length === 0) return;

            let keyword = '';
            let volume = '';
            const bullets = [];
            const trendWords = [];
            let section = 'bullets'; // where un-labelled bullets go by default

            lines.forEach((line) => {
              // A stray next section header ends this card's content.
              if (/^###\s+/.test(line)) {
                section = null;
                return;
              }
              // Section LABEL lines only switch the mode — they are never content themselves.
              if (/^[-*•\s]*subtopic bullets\s*:?\s*$/i.test(line)) {
                section = 'bullets';
                return;
              }
              // Start of "trending points" section
              if (/^[-*•\s]*trending points of this keyword\s*:?\s*$/i.test(line)) {
                section = 'trend';
                return;
              }

              // Keyword labels (English / Arabic)
              const kwMatch = line.match(/^[-\s]*?(?:Keyword|كلمة رئيسية|الكلمة الرئيسية|الكلمة|كلمة)\s*[:\-]\s*(.+)$/i);
              if (kwMatch) { keyword = kwMatch[1].trim(); return; }

              // Search volume labels (English / Arabic)
              const volMatch = line.match(/^[-\s]*?(?:Search volume|حجم البحث)\s*[:\-]\s*(.+)$/i);
              if (volMatch) { volume = volMatch[1].trim(); return; }

              // Any remaining bullet is real content for the active section.
              const bulletMatch = line.match(/^[-*\u2022]\s*(.+)$/);
              if (bulletMatch) {
                const val = bulletMatch[1].trim();
                if (!val || isCardLabel(val)) return;
                if (section === 'trend') trendWords.push(val);
                else if (section === 'bullets') bullets.push(val);
              }
            });

            // Fallbacks
            if (!keyword) {
              const firstNonBullet = lines.find(l => !/^[-*\u2022]/.test(l));
              if (firstNonBullet) keyword = firstNonBullet.replace(/^\d+\.\s*/, '').trim();
            }
            if (!volume) {
              const volCandidate = lines.find(l => /\d[\d,\.\s]*$/.test(l) && /search|حجم|volume/i.test(l) === false);
              if (volCandidate) {
                const num = (volCandidate.match(/(\d[\d,\.\s]*)/) || [])[1];
                if (num) volume = num.replace(/[ ,]/g, '').trim();
              }
            }

            const cleanBullets = bullets.filter(b => !/(?:Keyword|Search volume|حجم البحث|كلمة)/i.test(b)).slice(0, 6);
            const cleanTrendWords = trendWords.filter(b => !/(?:Keyword|Search volume|حجم البحث|كلمة)/i.test(b)).slice(0, 6);

            if (keyword || volume || cleanBullets.length) {
              cards.push({
                keyword: keyword || '',
                volume: volume || '',
                bullets: cleanBullets,
                trendWords: cleanTrendWords
              });
            }
          });

          // NOTE: no cards.shift() here — the split above already drops the
          // pre-"### Card 1" preamble, so every remaining block is a real card.
          return cards;
        };

        // Helper to extract interest over time table (language-agnostic)
        const extractInterestOverTime = (text) => {
          // Find a markdown table block and parse rows like "| 2025-09-08 | 95 |"
          const anyTableMatch = text.match(/\|[^\n]*\|[^\n]*\n\|[-\s|:]*\n([\s\S]*?)(?=\n\s*###|$)/i);
          const rows = [];
          const parseTableContent = (tableContent) => {
            const lines = tableContent.split('\n').map(l => l.trim()).filter(l => l && /^\|/.test(l));
            for (let i = 0; i < lines.length; i++) {
              const cols = lines[i].split('|').map(c => c.trim()).filter(Boolean);
              if (cols.length >= 2) {
                const week = cols[0].replace(/[^0-9\-]/g, '').trim();
                const interest = cols[1].replace(/[^0-9.]/g, '').trim();
                if (week && interest) {
                  rows.push({ week, interest: Number(interest) });
                }
              }
            }
          };
          if (anyTableMatch) {
            parseTableContent(anyTableMatch[1]);
          } else {
            // Fallback: look for lines like '| 2025-09-08        | 95       |' anywhere
            const plainRows = text.split('\n').map(l => l.trim()).filter(l => /^\|/.test(l));
            if (plainRows.length) {
              plainRows.forEach(line => {
                const cols = line.split('|').map(c => c.trim()).filter(Boolean);
                if (cols.length >= 2) {
                  const week = cols[0].replace(/[^0-9\-]/g, '');
                  const interest = cols[1].replace(/[^0-9.]/g, '');
                  if (week && interest) rows.push({ week, interest: Number(interest) });
                }
              });
            }
          }
          // Fallback: find date-like patterns e.g., YYYY-MM-DD followed by a number
          if (rows.length === 0) {
            const dateNumRegex = /([0-9]{4}-[0-9]{2}-[0-9]{2})\s*\|?\s*(\d{1,3})/g;
            let m;
            while ((m = dateNumRegex.exec(text)) !== null) {
              rows.push({ week: m[1], interest: Number(m[2]) });
            }
          }
          return rows.slice(0, 12);
        };

        // Use the language-agnostic extractor for all main lists
        const allBlocks = extractOrderedSections(text);
        // The web scrape (researchData) sometimes returns only 1–3 items (with real
        // article URLs), while the AI text (allBlocks) has the full 10. Merge them —
        // scrape first to keep real URLs, then top up from allBlocks — so the lists
        // always fill up to 10.
        const normKey = (s) => {
          if (!s) return "";
          if (typeof s === "string") return s.toLowerCase().trim();
          if (typeof s === "object") return String(s.title || s.url || "").toLowerCase().trim();
          return String(s).toLowerCase().trim();
        };
        const mergeUpTo = (primary, secondary, max = 10) => {
          const out = [];
          const seen = new Set();
          // De-dupe the primary list itself too — the scrape/model output can
          // repeat the same headline verbatim, and previously only the top-up
          // ("secondary") pass was deduped, letting primary-list duplicates
          // straight through.
          for (const item of (Array.isArray(primary) ? primary : [])) {
            if (out.length >= max) break;
            const key = normKey(item);
            if (key && !seen.has(key)) { seen.add(key); out.push(item); }
          }
          for (const item of (Array.isArray(secondary) ? secondary : [])) {
            if (out.length >= max) break;
            const key = normKey(item);
            if (key && !seen.has(key)) { seen.add(key); out.push(item); }
          }
          return out;
        };
        // Empty arrays are truthy, so only use the scrape when it's non-empty;
        // otherwise start from the AI-parsed section.
        const pickFinal = (arr, fb) =>
          (Array.isArray(arr) && arr.length) ? arr : (fb || []);
        // The AI sometimes returns only 2–3 headlines even when topics/content
        // ideas have 10. Top each list up (deduped) from adjacent sections so the
        // "Top 10" lists actually fill out.
        const finalHeadlines = mergeUpTo(
          pickFinal(researchData.headlines, allBlocks[0]),
          [...(allBlocks[0] || []), ...(allBlocks[3] || []), ...(allBlocks[1] || [])],
        );
        const finalTopicsList = mergeUpTo(
          pickFinal(researchData.topTopics, allBlocks[1]),
          [...(allBlocks[1] || []), ...(allBlocks[3] || []), ...(allBlocks[2] || [])],
        );
        const finalKeywords = mergeUpTo(
          pickFinal(researchData.topKeywords, allBlocks[2]),
          allBlocks[2],
        );
        // Content Ideas / Questions can also come back short — top them up
        // (deduped) from adjacent sections so the Overview lists fill to 10.
        const finalContentHeadlines = mergeUpTo(
          allBlocks[3],
          [...(allBlocks[3] || []), ...(allBlocks[0] || []), ...(allBlocks[1] || [])],
        );
        const finalContentQuestions = mergeUpTo(
          allBlocks[4],
          [...(allBlocks[4] || []), ...(allBlocks[6] || [])],
        );
        const finalRelatedHeadlines = mergeUpTo(
          allBlocks[5],
          [...(allBlocks[5] || []), ...(allBlocks[0] || []), ...(allBlocks[3] || [])],
        );
        const finalRelatedQuestions = mergeUpTo(
          allBlocks[6],
          [...(allBlocks[6] || []), ...(allBlocks[4] || [])],
        );
        const finalTopKeyword = extractSingleFromBlock(allBlocks[7]);
        const finalCardData = extractCards(text);
        // Prefer real Google Trends data from the backend; fall back to parsing
        // the AI's text table only if Trends returned nothing (e.g. rate-limited).
        const backendInterest = Array.isArray(ragResult?.interest_over_time)
          ? ragResult.interest_over_time
          : [];
        const finalInterestOverTime =
          backendInterest.length > 0 ? backendInterest : extractInterestOverTime(text);

        setHeadlines(finalHeadlines);
        setSourceConfidence({});
        setSourceUrls({});
        (async () => {
          try {
            const [confidenceMap, sourceMap] = await Promise.all([
              fetchHeadlineConfidence(finalHeadlines),
              fetchHeadlineSources(finalHeadlines),
            ]);
            if (confidenceMap && Object.keys(confidenceMap).length) {
              setSourceConfidence((prev) => ({ ...prev, ...confidenceMap }));
            }
            if (sourceMap && Object.keys(sourceMap).length) {
              setSourceUrls((prev) => ({ ...prev, ...sourceMap }));
            }
          } catch (err) {
            console.error("Headline enrichment failed:", err);
          }
        })();
        setTopicsList(finalTopicsList);
        setKeywords(finalKeywords);
        setContentHeadlines(finalContentHeadlines);
        setContentQuestions(finalContentQuestions);
        setRelatedHeadlines(finalRelatedHeadlines);
        setRelatedQuestions(finalRelatedQuestions);
        setTopKeyword(finalTopKeyword);
        setCardData(finalCardData);
        setInterestOverTime(finalInterestOverTime);

        // Save to prompt history (async)
        const formDataForHistory = { topic, language };
        const researchResults = {
          headlines: finalHeadlines,
          topicsList: finalTopicsList,
          keywords: finalKeywords,
          contentHeadlines: finalContentHeadlines,
          contentQuestions: finalContentQuestions,
          relatedHeadlines: finalRelatedHeadlines,
          relatedQuestions: finalRelatedQuestions,
          topKeyword: finalTopKeyword,
          cardData: finalCardData,
          interestOverTime: finalInterestOverTime,
        };
        saveResearchHistory(formDataForHistory, researchResults)
          .then((saved) => {
            if (saved && saved.id) {
              setCurrentResearchId(saved.id);
            }
          })
          .catch((err) => {
            console.error("Error saving research history:", err);
          });
      } catch (e) {
        setGeneratedText("");
        setHeadlines([]);
        setTopicsList([]);
        setKeywords([]);
        setContentHeadlines([]);
        setContentQuestions([]);
        setRelatedHeadlines([]);
        setRelatedQuestions([]);
        setTopKeyword("");
        setCardData([]);
        setInterestOverTime([]);
      } finally {
        setLoadingSubmit(false);
      }
    };

  // Aborts the in-flight /rag/stream fetch — same pattern as the Writing
  // Assistant's stop control. The AI service keeps working server-side (no
  // cancellation API for that), but the client stops waiting immediately.
  const handleStopResearch = () => {
    if (researchAbortRef.current) {
      researchAbortRef.current.abort();
      researchAbortRef.current = null;
    }
    setLoadingSubmit(false);
    ShowToast(lang("Research stopped."), Severty.INFO);
  };

  const copyToClipboard = async (text, label = "Content") => {
    try {
      await navigator.clipboard.writeText(text || "");
      ShowToast(`${label} copied to clipboard`, Severty.SUCCESS);
    } catch {
      ShowToast("Failed to copy", Severty.ERROR);
    }
  };

  return (
    <>
      <Card bordered={false} className="criclebox tablespace mb-24">
        <div
          className="section-headding research-assistant-heading"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h4>{lang("Research Assistant")}</h4>
            <p>{lang("Research Assistant Description")}</p>
          </div>
          <Button
            icon={<HistoryOutlined />}
            onClick={() => setHistoryOpen(true)}
            className="chat-history-toggle-btn"
          >
            {lang("Prompt History")}
          </Button>
        </div>
        <section className="research-container">
          <div className="sidebar-left-research">
            <Form layout="vertical" form={form} onFinish={handleRunResearch}>
              <Form.Item
                label={<h6>{lang("Topic")}</h6>}
                required
              >
                <div className="textarea-with-mode">
                  {/* Topic textarea */}
                  <Form.Item
                    name="topic"
                    rules={[
                      { required: true, message: lang("Please enter a topic") },
                    ]}
                    noStyle
                  >
                    <Input.TextArea
                      placeholder={lang("Enter topic")}
                      rows={4}
                      className="topic-textarea"
                    />
                  </Form.Item>

                  {/* Mode dropdown */}
                  <Form.Item
                    name="researchMode"
                    initialValue="files"
                    noStyle
                  >
                    <Select
                      size="small"
                      className="mode-select"
                      dropdownMatchSelectWidth={false}
                      options={[
                        { value: "files", label: "Files" },
                        { value: "web", label: "Web" },
                        { value: "hybrid", label: "Hybrid" },
                      ]}
                    />
                  </Form.Item>
                </div>
                {/* name="topic"
                rules={[
                  { required: true, message: lang("Please enter a topic") },
                ]}
              >
                <Input.TextArea placeholder={lang("Enter topic")} row={4} /> */}
              </Form.Item>
              <Form.Item
                label={<div>{lang("Language")}</div>}
                name="language"
                initialValue="English"
              >
                <Select className="dropdown-research-select">
                  <Option value="English">{lang("English")}</Option>
                  <Option value="Arabic">{lang("Arabic")}</Option>
                </Select>
              </Form.Item>

              <Form.Item>
                {loadingSubmit ? (
                  <button
                    type="button"
                    className="wa-stop-pill"
                    onClick={handleStopResearch}
                  >
                    <span className="wa-stop-ring-wrap">
                      <svg className="wa-stop-ring" viewBox="0 0 36 36" aria-hidden="true">
                        <circle cx="18" cy="18" r="15" />
                      </svg>
                      <span className="wa-stop-core" />
                    </span>
                    {lang("Stop")}
                  </button>
                ) : (
                  <Button
                    type="primary"
                    block
                    className="run-button"
                    htmlType="submit"
                  >
                    {lang("Run Research")}
                  </Button>
                )}
              </Form.Item>
            </Form>
          </div>

          {/* ================= RAG OUTPUT ================= */}

          {loadingSubmit ? (
            <div className="content-area research-shimmer">
              <div className="research-shimmer-header">
                <p className="research-shimmer-title">
                  {lang("Research is running in the background...")}
                </p>
              </div>

              {/* Shimmer placeholder for the headlines list */}
              <div className="shimmer-block shimmer-heading" />
              <div className="shimmer-card-list">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="shimmer-card">
                    <div className="shimmer-block shimmer-line shimmer-line-lg" />
                    <div className="shimmer-block shimmer-line shimmer-line-sm" />
                  </div>
                ))}
              </div>

              {/* Shimmer placeholder for the topics tags */}
              <div className="shimmer-block shimmer-heading" />
              <div className="shimmer-tag-list">
                {[...Array(8)].map((_, i) => (
                  <div key={i} className="shimmer-block shimmer-tag" />
                ))}
              </div>
            </div>
          ) : headlines.length > 0 || topicsList.length > 0 ? (
            <div className="content-area">
              <Tabs defaultActiveKey="1" className="tabs-main-research">
                <TabPane
                  className="research-tabs"
                  tab={lang("Headlines & Trends")}
                  key="1"
                >
              <section className="headlines-section mt-0">
                <div className="headline-toll-headding">
                  <h6>{form.getFieldValue("researchMode") === "files" ? lang("TOP 10 TOPICS FOUND") : lang("TOP 10 HEADLINES")}</h6>
                  <div className="headline-actions">
                    <Button onClick={() => copyToClipboard(headlines.join("\n"))}>
                      <img src={CopyIocn} />
                    </Button>
                  </div>
                </div>
                <div className="headlines-list">
                  {headlines.length > 0 ? (
                    headlines.map((h, i) => (
                      <Card key={i} className="headline-card">
                        <div className="searching-listbar">
                          <div className="headline-text">
                            <span>{i + 1}.</span>
                            {editingHeadlineIndex === i ? (
                              <>
                                <Input
                                  value={editingHeadlineValue}
                                  onChange={e => setEditingHeadlineValue(e.target.value)}
                                  onPressEnter={() => {
                                    const newHeadlines = [...headlines];
                                    newHeadlines[i] = editingHeadlineValue;
                                    setHeadlines(newHeadlines);
                                    setEditingHeadlineIndex(null);
                                  }}
                                  onBlur={() => {
                                    const newHeadlines = [...headlines];
                                    newHeadlines[i] = editingHeadlineValue;
                                    setHeadlines(newHeadlines);
                                    setEditingHeadlineIndex(null);
                                  }}
                                  autoFocus
                                  style={{ width: "100%" }}
                                />
                                <Button
                                  type="primary"
                                  size="small"
                                  style={{ marginLeft: 8 }}
                                  onClick={() => {
                                    const newHeadlines = [...headlines];
                                    newHeadlines[i] = editingHeadlineValue;
                                    setHeadlines(newHeadlines);
                                    setEditingHeadlineIndex(null);
                                  }}
                                >
                                  Save
                                </Button>
                                <Button
                                  size="small"
                                  style={{ marginLeft: 4 }}
                                  onClick={() => setEditingHeadlineIndex(null)}
                                >
                                  Cancel
                                </Button>
                              </>
                            ) : (
                              <>
                                <a
                                  href={sourceUrls[h] || `https://www.google.com/search?q=${encodeURIComponent(h)}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#1890ff", textDecoration: "underline" }}
                                >
                                  {h}
                                </a>
                                {renderConfidenceBadge(h)}
                              </>
                            )}
                          </div>
                          <div className="headline-actions">
                            <Button
                              onClick={() => {
                                setEditingHeadlineIndex(i);
                                setEditingHeadlineValue(h);
                              }}
                            >
                              <img src={EditIcon} />
                            </Button>
                            <Button onClick={() => copyToClipboard(h)}>
                              <img src={CopyIocn} />
                            </Button>
                            <Button
                              className="table-primary-fill-btn"
                              onClick={() => {
                                if (onWrite) onWrite(h);
                              }}
                            >
                              Write
                            </Button>
                          </div>
                        </div>
                      </Card>
                    ))
                  ) : (
                    <div className="no-headlines">
                      <img src={NoSearchAssistant} alt="No Headlines" />
                      <p>{lang("No headlines generated yet. Please enter a topic and run research.")}</p>
                    </div>
                  )}
                </div>
              </section>

              <section className="topics-section">
                <div className="headline-toll-headding">
                  <h6>{lang("TOP 10 TOPICS")}</h6>
                  <div className="headline-actions">
                    <Button onClick={() => copyToClipboard(topicsList.join("\n"))}>
                      <img src={CopyIocn} />
                    </Button>
                  </div>
                </div>
                <div className="tags-grid">
                  {topicsList.length > 0 ? (
                    topicsList.map((topic, i) => (
                      <div className="tag-topics" key={i} style={{ display: 'flex', alignItems: 'center' }}>
                        {editingTopicIndex === i ? (
                          <>
                            <Input
                              value={editingTopicValue}
                              onChange={e => setEditingTopicValue(e.target.value)}
                              onPressEnter={() => {
                                const newTopics = [...topicsList];
                                newTopics[i] = editingTopicValue;
                                setTopicsList(newTopics);
                                setEditingTopicIndex(null);
                              }}
                              onBlur={() => {
                                const newTopics = [...topicsList];
                                newTopics[i] = editingTopicValue;
                                setTopicsList(newTopics);
                                setEditingTopicIndex(null);
                              }}
                              autoFocus
                              style={{ width: '80%' }}
                            />
                            <Button
                              type="primary"
                              size="small"
                              style={{ marginLeft: 8 }}
                              onClick={() => {
                                const newTopics = [...topicsList];
                                newTopics[i] = editingTopicValue;
                                setTopicsList(newTopics);
                                setEditingTopicIndex(null);
                              }}
                            >
                              Save
                            </Button>
                            <Button
                              size="small"
                              style={{ marginLeft: 4 }}
                              onClick={() => setEditingTopicIndex(null)}
                            >
                              Cancel
                            </Button>
                          </>
                        ) : (
                          <>
                            {topic}
                            <Button
                              size="small"
                              style={{ marginLeft: 8 }}
                              onClick={() => {
                                setEditingTopicIndex(i);
                                setEditingTopicValue(topic);
                              }}
                            >
                              <img src={EditIcon} alt="Edit" />
                            </Button>
                            <Button
                              size="small"
                              className="table-primary-fill-btn"
                              style={{ marginLeft: 8 }}
                              onClick={() => {
                                if (onWrite) onWrite(topic);
                              }}
                            >
                              Write
                            </Button>
                          </>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="no-data-message">
                      {lang("Please enter a topic and run research.")}
                    </div>
                  )}
                </div>
              </section>

              <section className="trends-section mb-3">
                <div className="headline-toll-headding">
                  <h6>{lang("TOP 10 TRENDS")}</h6>
                  <div className="headline-actions">
                    <Button>
                      <img src={EditIcon} />
                    </Button>
                    <Button onClick={() => copyToClipboard(keywords.join("\n"))}>
                      <img src={CopyIocn} />
                    </Button>
                  </div>
                </div>
                <div className="tags-grid">
                  {keywords.length > 0 ? (
                    keywords.map((kw, i) => (
                      <div className="tag-topics" key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                        {kw}
                        <Button
                          size="small"
                          className="table-primary-fill-btn"
                          onClick={() => {
                            if (onWrite) onWrite(kw);
                          }}
                        >
                          Write
                        </Button>
                      </div>
                    ))
                  ) : (
                    <div className="no-data-message">
                      {lang("Please enter a topic and run research.")}
                    </div>
                  )}
                </div>
              </section>
                </TabPane>

                <TabPane
                  className="research-tabs"
                  tab={lang("Graphical Insights")}
                  key="2"
                >
                  <GraphicalInsights interestOverTime={interestOverTime || []} />
                </TabPane>

                <TabPane
                  className="research-tabs"
                  tab={lang("Content Ideas")}
                  key="3"
                >
                  <ContentIdeas
                    contentHeadlines={contentHeadlines || []}
                    contentQuestions={contentQuestions || []}
                    relatedHeadlines={relatedHeadlines || []}
                    relatedQuestions={relatedQuestions || []}
                    topKeyword={topKeyword || ""}
                    cardData={cardData || []}
                    onWrite={onWrite}
                  />
                </TabPane>
              </Tabs>
            </div>
          ) : generatedText ? (
            // Fallback: AI returned an answer but it doesn't match the SEO
            // structure the parsers above expect (e.g. a free-form Q&A like
            // "summarise my resume"). Show the raw answer so it isn't lost.
            <div className="content-area">
              <section className="headlines-section">
                <div className="headline-toll-headding">
                  <h6>{lang("AI Answer")}</h6>
                  <div className="headline-actions">
                    <Button onClick={() => copyToClipboard(generatedText || "")}>
                      <img src={CopyIocn} />
                    </Button>
                  </div>
                </div>
                <Card className="headline-card">
                  <div style={{ whiteSpace: "pre-wrap", padding: "8px 4px" }}>
                    {generatedText}
                  </div>
                </Card>
              </section>
            </div>
          ) : (
            <div className="no-headlines no-research-done mx-auto text_name">
              <p>{lang("Please enter a topic and run research.")}</p>
            </div>
          )}
        </section>
      </Card>

      {/* Prompt History Sidebar */}
      <ResearchHistorySidebar
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        researchHistories={researchHistories}
        currentResearchId={currentResearchId}
        onCreateNew={() => {
          setCurrentResearchId(null);
          form.resetFields();
          setHeadlines([]);
          setTopicsList([]);
          setKeywords([]);
          setContentHeadlines([]);
          setContentQuestions([]);
          setRelatedHeadlines([]);
          setRelatedQuestions([]);
          setTopKeyword("");
          setCardData([]);
          setInterestOverTime([]);
          setHistoryOpen(false);
        }}
        onClearAll={() => {
          clearAllResearchHistories();
          setCurrentResearchId(null);
        }}
        onDeleteResearch={(id) => {
          deleteResearchHistory(id);
          if (currentResearchId === id) {
            setCurrentResearchId(null);
          }
        }}
        onSelectResearch={(history) => {
          setCurrentResearchId(history.id);
          if (history.formData) {
            form.setFieldsValue(history.formData);
          }
          if (history.researchResults) {
            const r = history.researchResults;
            setHeadlines(r.headlines || []);
            setTopicsList(r.topicsList || []);
            setKeywords(r.keywords || []);
            setContentHeadlines(r.contentHeadlines || []);
            setContentQuestions(r.contentQuestions || []);
            setRelatedHeadlines(r.relatedHeadlines || []);
            setRelatedQuestions(r.relatedQuestions || []);
            setTopKeyword(r.topKeyword || "");
            setCardData(r.cardData || []);
            setInterestOverTime(r.interestOverTime || []);
          }
          setHistoryOpen(false);
        }}
      />
    </>
  );
};

export default CollaborationTabs;
